import React, { useState, useEffect } from "react";
import { Input } from "components";
import { Button, FlexRight } from "appStyles";
import * as styles from "./editStore.styles";
import DoneIcon from "@material-ui/icons/Done";
import Switch from "@material-ui/core/Switch";
import NumberFormat from "react-number-format";
import {
  formatDollarsToCents,
  priceToDollars,
  getSortedDataToDisplay,
  sortDataByIdAndOrder,
} from "helpers";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import Modal from "@material-ui/core/Modal";
import AlertModal from "../../../Tools/AlertModal";
import SelectionItemOrdering from "./SelectionItemOrdering";
import {
  deleteGroup,
  createGroup,
  updateGroup,
  deleteGroupItem,
  createGroupItem,
} from "apis";

function CategoryGroup(props) {
  const {
    closeModal,
    categoryObjectsArray,
    updateGroups,
    group,
    storeItemId,
    createTempId,
    isMobileAdminView,
    accessToken,
  } = props;
  const [error, setError] = useState("");
  const [selectionError, setSelectionError] = useState("");
  const [showMax, setShowMax] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryObject, setCategoryObject] = useState(null);
  const [showCreateSelectionModal, setShowCreateSelectionModal] =
    useState(false);
  const [tempOrder, incrementTempOrder] = useState(null);
  const [showReorderSelectionModal, setShowReorderSelectionModal] =
    useState(false);
  const [tempSelection, setTempSelection] = useState({
    name: "",
    price: null,
    sortOrder: tempOrder,
  });

  useEffect(() => {
    if (group != null) {
      setCategoryObject(group);
      if (group.maxOptions > 0) {
        setShowMax(true);
      }
    }
  }, []);

  const toggleCreateSelectionModal = () => {
    // console.log("toggling create selection modal");
    setShowCreateSelectionModal(!showCreateSelectionModal);
  };

  const toggleReorderSelectionModal = () => {
    setShowReorderSelectionModal(!showReorderSelectionModal);
  };

  const toggleShowMax = () => {
    if (showMax) {
      setShowMax(false);
      setCategoryObject({
        ...categoryObject,
        maxOptions: -1,
      });
    } else {
      setShowMax(true);
      setCategoryObject({
        ...categoryObject,
        maxOptions: 1,
      });
    }
  };

  const update = (field) => (value) => {
    if (field === "isMandatory") {
      value = value.target.checked;
      // if isMandatory is true (or isOptional is false, used isMandatory for better readability)
      if (value) {
        categoryObject.minOptions = 1;
        // categoryObject.maxOptions = 1;
        categoryObject.isOptional = false;
      } else {
        categoryObject.minOptions = -1;
        categoryObject.isOptional = true;
      }
    }

    setCategoryObject({
      ...categoryObject,
      [field]: value,
    });
  };

  const updateTempSelection = (field) => (value) => {
    if (field === "price") {
      value = formatDollarsToCents(value["value"]);
    }
    setTempSelection({
      ...tempSelection,
      [field]: value,
    });
  };

  const createLongTempId = (length) => {
    var result = "";
    var characters = "0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const hasActiveGroupItems = () => {
    if (!Array.isArray(categoryObject.additionalOptionsItems)) return false;
    let activeItems = categoryObject.additionalOptionsItems.filter(
      (item) => item.retired === 0 || item.retired === undefined
    );
    return activeItems.length > 0;
  };

  const handleChanges = async () => {
    setError("");
    if (categoryObject.title === "" || !hasActiveGroupItems()) {
      setError("Name and at least one selection item is required.");
      return;
    }
    // if creating a brand new group in a new store item or if updating a group in a cloned item
    if (categoryObject.id === "NewGroup" && storeItemId === "newStoreItem") {
      categoryObject.id = createLongTempId(20);
      categoryObjectsArray.push(categoryObject);
      updateGroups(categoryObjectsArray);
    }

    // if editing a non saved store item group
    if (categoryObject.id.toString().length === 20) {
      const found = categoryObjectsArray.find(
        (group) => group.id === categoryObject.id
      );
      categoryObjectsArray[
        categoryObjectsArray.findIndex(
          (group) => group.id === categoryObject.id
        )
      ] = categoryObject;
    }

    // if creating a new group with existing store item
    if (storeItemId != "newStoreItem" && categoryObject.id === "NewGroup") {
      delete categoryObject.id;
      // console.log("here is the group before update");
      // console.dir(categoryObject);
      categoryObject.additionalOptionsItems.forEach((item) => {
        delete item.id;
      });
      // console.log("here is the group after deleting ids");
      // console.dir(categoryObject);
      const result = await createGroup(
        storeItemId,
        categoryObject,
        accessToken
      );
      categoryObjectsArray.push(result);
      updateGroups(categoryObjectsArray);
    } else if (
      storeItemId != "newStoreItem" &&
      categoryObject.id != "NewGroup"
    ) {
      updateGroupHelper(categoryObject.id, categoryObject);
    }

    closeModal();
  };

  const updateGroupHelper = async (groupId, group) => {
    // console.log("OOOOO=====>>>> updating group");
    delete group.purchaseItem;
    const result = await updateGroup(groupId, group, accessToken);
    findAndDeleteGroup(categoryObject, categoryObjectsArray);
    categoryObjectsArray.push(result);
    updateGroups(categoryObjectsArray);
  };

  const findAndDeleteGroup = (groupToDelete, groups) => {
    groups.splice(
      groups.findIndex((group) => group.id === groupToDelete.id),
      1
    );
  };

  const toggleDeleteGroupModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const getDeleteGroupButtons = () => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={toggleDeleteGroupModal}
      >
        Cancel
      </a>,
      <a
        key="deleteButton"
        variant="contained"
        onClick={deleteGroupHelper}
        style={{
          cursor: "pointer",
          backgroundColor: "white",
          color: "red",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          paddingLeft: "10px",
          fontSize: "0.9375rem",
        }}
      >
        Delete
      </a>,
    ];
  };

  const deleteGroupHelper = () => {
    deleteGroup(categoryObject.id, accessToken);
    findAndDeleteGroup(categoryObject, categoryObjectsArray);
    closeModal();
  };

  const renderDeleteGroupModal = () => {
    if (!showDeleteModal) return null;
    return (
      <AlertModal
        title="Delete Selections Group"
        buttons={getDeleteGroupButtons()}
        render={showDeleteModal}
      >
        <styles.P style={{ color: "red" }}>
          Are you sure you want to delete your selections group?
          <br></br>
          <br></br>
        </styles.P>
        <br></br>
      </AlertModal>
    );
  };

  const handleCancel = () => {
    // if creating a brand new group
    if (categoryObject.id === "NewGroup") {
      closeModal();
      return;
    }
    // console.log("XXXXXXXXX: deleting group item");
    // if editing a non saved store item group
    // console.log(categoryObject.id);
    if (categoryObject.id.toString().length === 20) {
      // console.log("deleting a non saved store item group");
      findAndDeleteGroup(categoryObject, categoryObjectsArray);
      closeModal();
    } else {
      // perform delete on saved store item group
      toggleDeleteGroupModal();
    }
  };

  // console.log("child being edited");
  // console.dir(categoryObject);
  // console.log("parent array");
  // console.dir(categoryObjectsArray);

  const addSelection = async () => {
    setError("");
    setSelectionError("");
    if (tempSelection.name === "") {
      setSelectionError("Please provide a name for your selection.");
      return;
    }
    if (tempSelection.price === null) {
      tempSelection.price = 0;
    }

    // adding a new selection to a new group and a new item
    if (storeItemId === "newStoreItem") {
      // console.log(
      //   "XXXXX: adding a new selection to a new group and a new item"
      // );
      tempSelection.id = createTempId();
      tempSelection.sortOrder = null;
      incrementTempOrder(tempOrder + 1);
    }
    // adding a new selection to a new group and existing item
    else if (
      storeItemId != "newStoreItem" &&
      categoryObject.id === "NewGroup"
    ) {
      // console.log(
      //   "XXXXX: adding a new selection to a new group and existing item"
      // );
      tempSelection.id = createTempId();
      tempSelection.sortOrder = null;
    }

    categoryObject.additionalOptionsItems.push(tempSelection);

    // adding a new selection for existing group and existing item
    if (storeItemId != "newStoreItem" && categoryObject.id != "NewGroup") {
      // console.log(
      //   "XXXXX: adding a new selection for existing group and existing item"
      // );
      const result = await createGroupItem(
        categoryObject.id,
        tempSelection,
        accessToken
      );
      const last = categoryObject.additionalOptionsItems.length - 1;
      categoryObject.additionalOptionsItems[last] = result;
      setTempSelection({ name: "", price: null, sortOrder: null });
    }
    setTempSelection({ name: "", price: null, sortOrder: null });
    toggleCreateSelectionModal();
  };

  const renderMaxOptions = () => {
    return (
      <div
        style={{
          alignSelf: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            alignSelf: "flex-start",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              margin: "13px 15px 15px 0px",
            }}
          >
            Set a maximum number of selections
          </p>

          <Switch
            checked={showMax}
            onChange={toggleShowMax}
            color="primary"
            name="maxOptions"
            inputProps={{ "aria-label": "primary checkbox" }}
            // disabled={!isEditable}
          />

          {showMax && (
            <div
              style={{
                display: "flex",
              }}
            >
              <Input
                name="Maximum # of options"
                field="Maximum # of options"
                validateInput="true"
                defaultValue={categoryObject.maxOptions}
                onChange={update("maxOptions")}
                type={"number"}
                min={1}
                width={"60px"}
                marginBottom={"0px"}
                marginLeft={"20px"}
              />
              <br />
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderIsOptional = () => {
    return (
      <div
        style={{
          alignSelf: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            alignSelf: "flex-start",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              margin: "13px 15px 15px 0px",
            }}
          >
            Is Selection Mandatory
          </p>
          <Switch
            checked={categoryObject.isMandatory}
            onChange={update("isMandatory")}
            color="primary"
            name="optional"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          {categoryObject.isMandatory ? "Yes" : "No"}
        </div>
      </div>
    );
  };

  const deleteOptionsItem = (idx, item) => {
    let newState = categoryObject;

    var lists = newState.additionalOptionsItems.filter((x) => {
      return x.id != item.id;
    });
    newState.additionalOptionsItems = lists;

    setCategoryObject({ ...newState });

    // delete for existing store item
    if (storeItemId != "newStoreItem" && categoryObject.id != "NewGroup") {
      // console.log("deleting item for existing store item");
      // console.dir(item);
      deleteGroupItem(item.id, accessToken);
    }
  };

  const renderOptionsItems = () => {
    if (
      !categoryObject.additionalOptionsItems ||
      categoryObject.additionalOptionsItems.length === 0
    )
      return null;

    // go through all groups and add their title to array based on order recieved
    const displayItems = getSortedDataToDisplay(
      categoryObject.additionalOptionsItems
    );

    // console.log("modal rendering group items");
    // console.dir(displayItems);
    return (
      <div
        style={{
          margin: "auto",
          width: "292px",
        }}
      >
        {displayItems.map((item, idx) => {
          // console.dir(item);
          if (item.retired) return null;
          return (
            <div className={styles.itemOptionRow} key={idx}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "0.9375rem",
                }}
              >
                <p>{item.name}</p>
                {item.price != 0 && <p>+{priceToDollars(item.price)}</p>}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginTop: "5px",
                }}
              >
                <a
                  style={{
                    textDecoration: "underline",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  onClick={() => deleteOptionsItem(idx, item)}
                >
                  Delete
                </a>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderCreateSelectionModal = () => {
    if (!showCreateSelectionModal) return null;
    return (
      <Modal
        open={showCreateSelectionModal}
        onClose={toggleCreateSelectionModal}
        style={{
          top: isMobileAdminView ? "1%" : "25%",
          width: isMobileAdminView ? "100%" : "50%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            height: "auto",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
          }}
        >
          <styles.H2 style={{ marginBottom: "15px" }}>
            Create Selection Item
          </styles.H2>

          <div
            style={{
              margin: "10px 0px",
              fontSize: "0.875rem",
            }}
          >
            <p
              style={{
                margin: "10px 0px",
                fontSize: "1rem",
              }}
            >
              Item Name
            </p>
            <p
              style={{
                margin: "10px 0px",
                fontSize: "0.7rem",
              }}
            >
              Example: If this group was to select "Toppings" for a pizza, you
              would add items like "pepperoni", "olives","onions", etc.
            </p>
            <Input
              name="Name"
              field="Item Name (e.g. “Pepperoni” or “Small”)"
              defaultValue={tempSelection.name}
              onChange={updateTempSelection("name")}
              width={isMobileAdminView ? "100%" : "362px"}
            />
            <br />
            <br />
            <p
              style={{
                margin: "10px 0px",
                fontSize: "1rem",
              }}
            >
              Additional Cost
            </p>
            <p
              style={{
                margin: "10px 0px",
                fontSize: "0.7rem",
              }}
            >
              How much will this item cost on top of the base price of the item?
              If there is no additional cost, input $0.00.
            </p>
            <NumberFormat
              placeholder="$0.00"
              thousandSeparator={true}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              allowLeadingZeros={false}
              defaultValue={
                tempSelection.price ? priceToDollars(tempSelection.price) : null
              }
              onValueChange={updateTempSelection("price")}
              className={styles.inputStyle}
              style={{
                width: "100px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <p style={{ color: "red" }}>{selectionError}</p>
            <Button
              onClick={addSelection}
              background="#89D2D3"
              className={styles.buttonStyle}
              style={{ marginRight: "0px" }}
            >
              Create
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const getGroup = () => {
    return categoryObject;
  };

  const renderReorderSelectionItemsModal = () => {
    if (!showReorderSelectionModal) return null;
    return (
      <Modal
        open={showReorderSelectionModal}
        disableAutoFocus={true}
        onClose={toggleReorderSelectionModal}
        style={{
          margin: "auto",
          width: isMobileAdminView ? "100%" : "35%",
          top: isMobileAdminView ? "1%" : "10%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "560px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={toggleReorderSelectionModal}
          >
            <CloseIcon></CloseIcon>
          </span>
          <SelectionItemOrdering
            items={categoryObject.additionalOptionsItems}
            closeItemsModal={toggleReorderSelectionModal}
            getGroup={getGroup}
            group={categoryObject}
            updateGroup={setCategoryObject}
            groups={categoryObjectsArray}
            accessToken={accessToken}
            {...props}
          />
        </div>
      </Modal>
    );
  };

  const renderSelectionButtons = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: isMobileAdminView ? "center" : "flex-end",
        }}
      >
        {categoryObject.additionalOptionsItems.length > 1 && (
          <Button
            onClick={toggleReorderSelectionModal}
            background="#89D2D3"
            className={styles.buttonStyle}
            style={{ marginLeft: "0px" }}
          >
            <ShuffleIcon style={{ marginRight: "5px" }}></ShuffleIcon>
            Reorder Items
          </Button>
        )}
        <Button
          onClick={toggleCreateSelectionModal}
          background="#89D2D3"
          className={styles.buttonStyle}
          style={{ marginLeft: "0px" }}
        >
          + Add Selection Item
        </Button>
      </div>
    );
  };

  const renderSelections = () => {
    return (
      <div>
        <div
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
        >
          <styles.H2 style={{ textDecoration: "underline" }}>
            Selection Items
          </styles.H2>
        </div>
        {renderOptionsItems()}
        {renderSelectionButtons()}
        {renderCreateSelectionModal()}
        {renderReorderSelectionItemsModal()}
      </div>
    );
  };

  if (!categoryObject) return null;
  return (
    <div
      style={{
        height: "90%",
        backgroundColor: "#fff",
        padding: "1em",
        color: "black",
        overflowY: "auto",
        overflowX: isMobileAdminView ? "hidden" : "auto",
        display: "flex",
        flexDirection: "column",
        minHeight: "90vh",
      }}
    >
      <div style={{ flex: "1" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex" }}>
            <styles.H2 style={{ margin: "0px" }}>
              {categoryObject.id === "NewGroup" ? "Create " : "Update "}{" "}
              Selections Group
            </styles.H2>
          </div>
          {(hasActiveGroupItems() ||
            storeItemId === "newStoreItem" ||
            categoryObject.id === "NewGroup") && (
            <span
              style={{
                cursor: "pointer",
                fontSize: "0.9375rem",
                lineHeight: "14px",
                color: "black",
                marginLeft: "10px",
              }}
              onClick={closeModal}
            >
              <CloseIcon fontSize={"large"}></CloseIcon>
            </span>
          )}
        </div>
        <p
          style={{ fontSize: "12px", marginTop: "10px", marginBottom: "10px" }}
        ></p>
        <Input
          name="Group Name"
          field="Group Name (e.g. “Toppings” or “Size”)"
          validateInput="true"
          defaultValue={categoryObject.title}
          onChange={update("title")}
          width={"100%"}
          marginBottom={"20px"}
        />
        <br />
        <Input
          name="Group Description"
          field="Group Description (e.g. “Pick from our fresh ingredients.”)"
          validateInput="true"
          defaultValue={categoryObject.subtitle}
          onChange={update("subtitle")}
          width={"100%"}
          marginBottom={"20px"}
        />
        <br />
        {renderIsOptional()}
        {renderMaxOptions()}
        {renderDeleteGroupModal()}
        {renderSelections()}
      </div>
      <FlexRight
        style={{
          marginTop: "20px",
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={handleCancel}
          background="#F17F7F"
          className={styles.buttonStyle}
        >
          <CancelIcon style={{ marginRight: "5px" }}></CancelIcon>
          {categoryObject.id === "NewGroup" ? "Cancel" : "Delete"}
        </Button>
        <p style={{ color: "red" }}>{error}</p>
        <Button
          onClick={handleChanges}
          background="#89D2D3"
          className={styles.buttonStyle}
        >
          <DoneIcon style={{ marginRight: "5px" }}></DoneIcon>
          {categoryObject.id === "NewGroup" ? "Create " : "Update "}
        </Button>
      </FlexRight>
    </div>
  );
}

export default CategoryGroup;
